var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYerlemDarkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1037,
    height: 1037,
    viewBox: "0 0 1037 1037",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 518.5,
    cy: 518.5,
    r: 518.5,
    fill: "#333B64"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M597.752 203.887C608.579 216.089 618.787 228.87 628.325 242.178H719.269C694.965 225.76 663.393 212.241 635.089 202.146C598.623 189.747 559.381 183 518.5 183C475.746 183 434.783 190.38 396.914 203.887H597.752Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M456.735 269.157C448.134 276.595 439.918 284.438 432.12 292.654H659.885C666.458 304.811 672.519 317.295 678.036 330.076H808.848C798.953 315.932 786.296 302.551 774.341 290.043C767.294 282.773 759.916 275.803 752.23 269.157H456.735Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.653 380.55C260.602 372.241 264.892 364.112 269.507 356.183L823.87 355.314C828.162 362.689 832.174 370.236 835.891 377.941C842.034 390.866 848.184 404.231 852.609 417.973H706.159C703.368 405.001 700.05 392.229 696.23 379.681L256.653 380.55Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.79 443.211C175.861 451.228 174.23 459.354 172.909 467.579H714.117C715.465 480.2 716.322 492.97 716.668 505.871H868C867.516 492.307 865.912 478.948 863.806 465.838C862.538 458.207 861.002 450.662 859.21 443.211H177.79Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.783 555.476C169.891 547.435 169.293 539.309 169 531.108H868C867.707 539.309 867.109 547.435 866.217 555.476C866.217 555.476 862.22 581.257 859.21 593.768H711.016C712.999 581.164 714.489 568.393 715.466 555.476H170.783Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.864 619.006C244.525 627.269 247.509 635.396 250.8 643.373H700.472C696.973 656.37 692.94 669.143 688.397 681.665H823.87C831.032 669.358 838.137 656.573 843.673 643.373C846.964 635.396 849.948 627.269 852.609 619.006H241.864Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M419.764 730.4C413.145 722.562 406.885 714.432 401.009 706.033L808.848 706.903C802.972 715.302 796.712 723.433 790.094 731.271C778.642 744.649 764.656 757.162 751.219 768.692H646.292C646.292 768.692 660.725 744.093 667.117 731.271L419.764 730.4Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M316.449 793.93C329.661 802.941 343.552 811.092 358.034 818.298H611.052C602.725 828.55 559.161 854.849 559.386 853.979C559.612 853.109 650.746 831.949 678.966 818.298C693.448 811.092 707.339 802.941 720.551 793.93H316.449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYerlemDarkLogo);
export default __webpack_public_path__ + "static/media/yerlem-dark-logo.7bca23a53a2e24a73fe39c450c4bf5f6.svg";
export { ForwardRef as ReactComponent };